import { render, staticRenderFns } from "./ReviewCarousel.vue?vue&type=template&id=475cb8c2&scoped=true&"
import script from "./ReviewCarousel.vue?vue&type=script&lang=js&"
export * from "./ReviewCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCarousel.vue?vue&type=style&index=0&id=475cb8c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475cb8c2",
  null
  
)

export default component.exports